/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/* ==========================================================================
   MEDDEY THEME INTERACTIVE ENHANCEMENTS (ENTERPRISE GRADE)
   ========================================================================== */

function meddeyToggleCatDropdown(btn) {
  var menu = document.getElementById('meddey-header-cat-menu');
  if (!menu) return;
  var isExpanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', !isExpanded);
  menu.hidden = isExpanded;
}

document.addEventListener('click', function(e) {
  var wrap = document.querySelector('.meddey-categories-dropdown-wrapper');
  if (wrap && !wrap.contains(e.target)) {
    var menu = document.getElementById('meddey-header-cat-menu');
    var btn = wrap.querySelector('.meddey-categories-trigger');
    if (menu) menu.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }
});

// Catalogue side drawer (<details class="mhc-more">). The scrim is the element's
// own ::before, so a tap on it reports the <details> itself as the target.
function closeCatalogueDrawer(e) {
  document.querySelectorAll('.mhc-more[open]').forEach(function(details) {
    if (details === e.target || !details.contains(e.target)) details.open = false;
  });
}

document.addEventListener('click', closeCatalogueDrawer);

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.mhc-more[open]').forEach(function(details) {
    details.open = false;
    var summary = details.querySelector('summary');
    if (summary) summary.focus();
  });
});

// Ajax Add to Cart for Meddey Spotlight & Quick Add Forms
document.addEventListener('DOMContentLoaded', function() {
  function bindAjaxForms(selector, btnSelector) {
    document.querySelectorAll(selector).forEach(function(form) {
      if (form.__ajaxBound) return;
      form.__ajaxBound = true;
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector(btnSelector);
        var originalContent = btn ? btn.innerHTML : '';
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = '<span>Adding...</span>';
        }

        var status=form.querySelector('[data-add-status]'); if (status) status.textContent='';
        var formData = new FormData(form);
        fetch((window.themeVariables?.routes?.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function(item) {
          if (btn) {
            btn.innerHTML = '<span>Added!</span>';
            setTimeout(function() {
              btn.disabled = false;
              btn.innerHTML = originalContent;
            }, 1400);
          }
          // Refresh Focal cart & open drawer
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
          var miniCart = document.getElementById('mini-cart');
          if (miniCart) {
            miniCart.open = true;
            miniCart.setAttribute('open', '');
          }
        })
        .catch(function(err) {
          var status=form.querySelector('[data-add-status]');
          if (!status) { status=document.createElement('p'); status.dataset.addStatus=''; status.setAttribute('role','alert'); form.append(status); }
          status.textContent='Unable to add this item. Please check availability and try again.';
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalContent;
          }
        });
      });
    });
  }

  document.addEventListener('shopify:section:load', function() { bindAjaxForms('.meddey-spotlight-form', '.meddey-btn-spotlight-atc'); });
  bindAjaxForms('.meddey-spotlight-form', '.meddey-btn-spotlight-atc');
  bindAjaxForms('.meddey-quick-add-form', '.meddey-btn-quick-add');
});


/* --------------------------------------------------------------------------
   Search / collection browsing helpers

   Everything here is delegated from the document because <product-facet>
   replaces the innerHTML of #facet-main and #facet-filters on every AJAX
   filter change, which would detach any directly bound listener.
   -------------------------------------------------------------------------- */
(() => {
  const DENSITY_KEY = 'theme:phone-products-per-row:v2';

  const sectionOf = (node) => node.closest('.shopify-section');

  const syncDensityButtons = (root = document) => {
    root.querySelectorAll('.meddey-density').forEach((group) => {
      const section = sectionOf(group);
      const current = section && section.dataset.density;

      group.querySelectorAll('[data-density]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.density === current ? 'true' : 'false');
      });
    });
  };

  // The section's own <style> block sets --section-products-per-row through an
  // #id selector, so the override has to be an inline style to win — and only
  // on phones. Larger screens keep the theme editor's responsive columns.
  const phone = window.matchMedia('screen and (max-width: 740px)');

  const applyStoredDensity = () => {
    let stored = null;
    const shouldRemember = !window.MeddeyConfig || window.MeddeyConfig.rememberUserColumns !== false;

    if (shouldRemember) {
      try {
        stored = localStorage.getItem(DENSITY_KEY);
      } catch (e) {
        /* storage blocked — the theme default stands */
      }
    }

    document.querySelectorAll('.meddey-density').forEach((group) => {
      const section = sectionOf(group);

      if (!section) {
        return;
      }

      // Check if switcher is disabled globally
      if (window.MeddeyConfig && window.MeddeyConfig.enableColumnSwitcher === false) {
        group.style.display = 'none';
      }

      // Respect the active phone choice, then the saved choice or section default.
      const defaultDensity = group.dataset.mobileDefault || '2';
      const effectiveDensity = ['1', '2'].includes(section.dataset.density) ? section.dataset.density : (['1', '2'].includes(stored) ? stored : (['1', '2'].includes(defaultDensity) ? defaultDensity : '2'));

      section.dataset.density = effectiveDensity;

      if (phone.matches && effectiveDensity) {
        section.style.setProperty('--section-products-per-row', effectiveDensity);
      } else {
        section.style.removeProperty('--section-products-per-row');
      }
    });

    syncDensityButtons();
  };

  phone.addEventListener('change', applyStoredDensity);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.meddey-density [data-density]');

    if (!button) {
      return;
    }

    const section = sectionOf(button);

    if (!section) {
      return;
    }

    const newDensity = button.dataset.density;
    if (!phone.matches || !['1', '2'].includes(newDensity)) return;
    section.dataset.density = newDensity;

    const shouldRemember = !window.MeddeyConfig || window.MeddeyConfig.rememberUserColumns !== false;
    if (shouldRemember) {
      try {
        localStorage.setItem(DENSITY_KEY, newDensity);
      } catch (e) {
        /* not persisted, still applied for this page */
      }
    }

    applyStoredDensity();
  });

  /* Type-to-narrow inside a long filter group. */
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-facet-search]');

    if (!input) {
      return;
    }

    const group = input.closest('.collapsible__content') || input.parentElement.parentElement;
    const list = group.querySelector('[data-facet-values]');

    if (!list) {
      return;
    }

    const query = input.value.trim().toLowerCase();
    let visible = 0;

    list.querySelectorAll('[data-facet-label]').forEach((item) => {
      const matches = query === '' || item.dataset.facetLabel.includes(query);

      item.style.display = matches ? '' : 'none';
      if (matches) visible += 1;
    });

    // While searching, the "show all" collapse must not hide a match.
    list.classList.toggle('facet-values--searching', query !== '');

    const empty = list.querySelector('.facet-values__empty');

    if (empty) {
      empty.hidden = visible > 0;
    }
  });

  const start = () => {
    applyStoredDensity();

    const main = document.getElementById('facet-main');

    if (main) {
      let densityDebounce = null;
      new MutationObserver(() => {
        clearTimeout(densityDebounce);
        densityDebounce = setTimeout(applyStoredDensity, 120);
      }).observe(main, { childList: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* Wide tables pasted into the Shopify admin editor overflow the layout, so give
   each one the theme's scrollable wrapper. */
(() => {
  const wrapTables = () => {
    document.querySelectorAll('.rte table').forEach((table) => {
      if (table.parentElement.classList.contains('table-wrapper') || table.parentElement.classList.contains('meddey-table-responsive')) {
        return;
      }

      const wrapper = document.createElement('div');

      wrapper.className = 'table-wrapper meddey-table-responsive';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    });

    if (typeof window.patchMeddeyTables === 'function') {
      window.patchMeddeyTables();
    }
  };

  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => idle(wrapTables));
  } else {
    idle(wrapTables);
  }
})();


/* Pointer dragging for .meddey-swipe rows. Touch devices already swipe natively,
   so this only runs for a mouse. Delegated from the document so sections
   re-rendered by the theme editor keep working. */
(() => {
  let drag = null;

  const stop = () => {
    if (!drag) {
      return;
    }

    const wasMoved = drag.moved;
    const row = drag.row;
    row.classList.remove('is-dragging');
    drag = null;

    if (wasMoved) {
      if (row.hasAttribute('data-hero-track') && row.clientWidth > 0) {
        const target = Math.round(row.scrollLeft / row.clientWidth) * row.clientWidth;
        row.scrollTo({ left: target, behavior: 'smooth' });
      }

      const suppressClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      };
      window.addEventListener('click', suppressClick, { capture: true, once: true });
      setTimeout(() => {
        window.removeEventListener('click', suppressClick, { capture: true });
      }, 120);
    }
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) {
      return;
    }

    const row = event.target.closest('.meddey-swipe');

    if (!row || row.scrollWidth <= row.clientWidth) {
      return;
    }

    drag = { row, startX: event.clientX, startLeft: row.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', (event) => {
    if (!drag) {
      return;
    }

    const delta = event.clientX - drag.startX;

    if (!drag.moved) {
      if (Math.abs(delta) < 8) {
        return;
      }

      drag.moved = true;
      drag.row.classList.add('is-dragging');
    }

    drag.row.scrollLeft = drag.startLeft - delta;
  });

  document.addEventListener('pointerup', stop);
  document.addEventListener('pointercancel', stop);
  window.addEventListener('blur', stop);
})();








/* --------------------------------------------------------------------------
   QUICK VIEW — IMAGE PICKER

   The quick-buy drawer is injected after a fetch, so the listener is delegated
   rather than bound to the thumbnails. Swapping src alone is enough: the stage
   image is served at one size, so there is no srcset to keep in step.
   -------------------------------------------------------------------------- */

document.addEventListener('click', (event) => {
  const thumb = event.target.closest?.('[data-quick-buy-thumb]');

  if (!thumb) {
    return;
  }

  const gallery = thumb.closest('.quick-buy-gallery');
  const stage = gallery?.querySelector('.quick-buy-gallery__image');

  if (!stage) {
    return;
  }

  event.preventDefault();
  stage.src = thumb.dataset.quickBuyThumb;

  gallery.querySelectorAll('[data-quick-buy-thumb]').forEach((item) => {
    if (item === thumb) {
      item.setAttribute('aria-current', 'true');
    } else {
      item.removeAttribute('aria-current');
    }
  });
});


/* --------------------------------------------------------------------------
   Meddey Hero Slider: Autoplay, arrows, dots, video controls, multi-image
   thumbnail switching, and dynamic collection product switcher.
   -------------------------------------------------------------------------- */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (slider) => {
    if (slider.dataset.heroReady === 'true') {
      return;
    }

    slider.dataset.heroReady = 'true';

    // 1. Video Player Controls (Play/Pause & Sound Toggle)
    slider.querySelectorAll('[data-hero-video-wrap]').forEach((wrap) => {
      const video = wrap.querySelector('video');
      const playBtn = wrap.querySelector('[data-hero-video-play]');
      const soundBtn = wrap.querySelector('[data-hero-video-sound]');

      if (video && playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play().catch(() => {});
            playBtn.classList.remove('is-paused');
            playBtn.innerHTML = '<svg viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>';
            playBtn.setAttribute('aria-label', 'Pause video');
          } else {
            video.pause();
            playBtn.classList.add('is-paused');
            playBtn.innerHTML = '<svg viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>';
            playBtn.setAttribute('aria-label', 'Play video');
          }
        });
      }

      if (video && soundBtn) {
        soundBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          if (video.muted) {
            soundBtn.classList.remove('is-unmuted');
            soundBtn.innerHTML = '<svg viewBox="0 0 24 24"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
            soundBtn.setAttribute('aria-label', 'Unmute video');
          } else {
            soundBtn.classList.add('is-unmuted');
            soundBtn.innerHTML = '<svg viewBox="0 0 24 24"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>';
            soundBtn.setAttribute('aria-label', 'Mute video');
          }
        });
      }
    });

    // 2. Multi-Image Thumbnail Gallery Switcher
    slider.querySelectorAll('[data-hero-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const visual = thumb.closest('[data-hero-visual]');
        if (!visual) return;
        const mainImg = visual.querySelector('[data-hero-main-img]');
        const newSrc = thumb.dataset.heroThumbSrc;
        const newAlt = thumb.dataset.heroThumbAlt;
        if (mainImg && newSrc) {
          mainImg.removeAttribute('srcset');
          mainImg.closest('picture')?.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
          mainImg.src = newSrc;
          if (newAlt) mainImg.alt = newAlt;
        }
        visual.querySelectorAll('[data-hero-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    // 3. Dynamic Product & Collection Switcher
    slider.querySelectorAll('[data-hero-prod-btn]').forEach((prodBtn) => {
      prodBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const slide = prodBtn.closest('[data-hero-slide]');
        if (!slide) return;
        const index = prodBtn.dataset.heroProdIndex;

        // Toggle nav button states
        slide.querySelectorAll('[data-hero-prod-btn]').forEach((b) => {
          const active = b === prodBtn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        // Switch active product panel in visual stage
        slide.querySelectorAll('[data-product-panel]').forEach((panel) => {
          const active = panel.dataset.productIndex === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        // Update dynamic pricing, compare price, discount badge, and CTA link
        const url = prodBtn.dataset.heroProdUrl;
        const price = prodBtn.dataset.heroProdPrice;
        const title = slide.querySelector('[data-hero-dynamic-title]');
        if (title && prodBtn.dataset.heroProdTitle) title.textContent = prodBtn.dataset.heroProdTitle;
        const compare = prodBtn.dataset.heroProdCompare;
        const disc = prodBtn.dataset.heroProdDisc;

        const cta = slide.querySelector('[data-hero-dynamic-cta]');
        if (cta && url) cta.href = url;

        const priceEl = slide.querySelector('[data-hero-dynamic-price]');
        if (priceEl && price) priceEl.textContent = price;

        const compareEl = slide.querySelector('[data-hero-dynamic-compare]');
        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        const badgeEl = slide.querySelector('[data-hero-dynamic-badge]');
        if (badgeEl) {
          if (disc) {
            badgeEl.textContent = disc;
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
      });
    });

    // 4. Custom HTML Sandbox Script Error Boundary & Performance Protection
    slider.querySelectorAll('.meddey-hero__custom-html-sandbox').forEach((sandbox) => {
      if (sandbox.dataset.sandboxReady === 'true') return;
      sandbox.dataset.sandboxReady = 'true';

      // Enforce lazy loading and async decoding on images/iframes to protect Core Web Vitals
      sandbox.querySelectorAll('img').forEach((img) => {
        if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
        if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      });
      sandbox.querySelectorAll('iframe').forEach((iframe) => {
        if (!iframe.hasAttribute('loading')) iframe.setAttribute('loading', 'lazy');
      });

      // Sandboxed script execution for dynamic theme customizer updates & safe error containment
      sandbox.querySelectorAll('script').forEach((oldScript) => {
        if (oldScript.dataset.scriptHandled === 'true') return;
        oldScript.dataset.scriptHandled = 'true';

        const type = oldScript.getAttribute('type');
        if (type && type !== 'text/javascript' && type !== 'application/javascript') return;

        try {
          if (!oldScript.src && oldScript.textContent.trim()) {
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
              const safeRun = new Function('sandbox', `
                try {
                  ${oldScript.textContent}
                } catch(sandboxError) {
                  console.warn("[Meddey Custom HTML Sandbox] Contained execution error:", sandboxError);
                }
              `);
              safeRun(sandbox);
            }
          } else if (oldScript.src) {
            const safeScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) => {
              safeScript.setAttribute(attr.name, attr.value);
            });
            safeScript.async = true;
            safeScript.onerror = (e) => {
              console.warn('[Meddey Custom HTML Sandbox] External script error boundary:', oldScript.src, e);
            };
            oldScript.parentNode.replaceChild(safeScript, oldScript);
          }
        } catch (err) {
          console.warn('[Meddey Custom HTML Sandbox] Safe evaluation caught error:', err);
        }
      });
    });

    // 5. Slide Carousel Navigation (Requires 2+ slides)
    const track = slider.querySelector('[data-hero-track]');
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));

    if (!track || slides.length < 2) {
      return;
    }

    // Slides 2+ hold their image in data-hero-src/srcset (see meddey-hero-banner) so they
    // don't share bandwidth with slide 1, the LCP image. Switch them on once slide 1 has
    // loaded, or as soon as the shopper moves the track.
    const wakeSlides = () => slider.querySelectorAll('[data-hero-srcset],[data-hero-src]').forEach((el) => {
      if (el.dataset.heroSrcset) el.srcset = el.dataset.heroSrcset;
      if (el.dataset.heroSrc) el.src = el.dataset.heroSrc;
      el.removeAttribute('data-hero-srcset');
      el.removeAttribute('data-hero-src');
    });
    const firstImg = slides[0].querySelector('img');
    if (!firstImg || firstImg.complete || window.Shopify?.designMode) {
      wakeSlides();
    } else {
      firstImg.addEventListener('load', wakeSlides, { once: true });
      firstImg.addEventListener('error', wakeSlides, { once: true });
    }
    track.addEventListener('pointerdown', wakeSlides, { once: true });
    track.addEventListener('scroll', wakeSlides, { once: true, passive: true });

    const indexOfCurrent = () => Math.round(track.scrollLeft / track.clientWidth);

    // Synchronize video playback with active slide
    const syncSlideVideos = (activeIdx) => {
      slides.forEach((s, i) => {
        const video = s.querySelector('video');
        if (!video) return;
        if (i === activeIdx) {
          if (video.hasAttribute('autoplay') || !video.paused) {
            video.play().catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    };

    const goTo = (index) => {
      const target = ((index % slides.length) + slides.length) % slides.length;

      track.scrollTo({
        left: target * track.clientWidth,
        behavior: reduced.matches ? 'auto' : 'smooth',
      });
      syncSlideVideos(target);
    };

    const syncDots = () => {
      const current = indexOfCurrent();

      dots.forEach((dot, i) => {
        const active = i === current;

        dot.classList.toggle('is-active', active);
        dot.setAttribute(dot.getAttribute('role') === 'tab' ? 'aria-selected' : 'aria-pressed', active ? 'true' : 'false');
      });

      syncSlideVideos(current);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.heroDot))));

    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');

    prev && prev.addEventListener('click', () => goTo(indexOfCurrent() - 1));
    next && next.addEventListener('click', () => goTo(indexOfCurrent() + 1));

    let scrollTimer = null;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncDots, 90);
    }, { passive: true });

    syncDots();
    track.addEventListener('click', (event) => {
      if (event.target.closest('a[href],button,input,video,iframe')) { slider.setAttribute('data-hero-user-paused', ''); return; }
      slider.toggleAttribute('data-hero-user-paused');
    });
    track.addEventListener('keydown', (event) => { if (event.target === track && event.key === ' ') { event.preventDefault(); slider.toggleAttribute('data-hero-user-paused'); } });

    // Autoplay Timer
    const seconds = Number(slider.dataset.heroAutoplay);

    if (!seconds || reduced.matches) {
      return;
    }

    let hovering = false;
    let dragging = false;

    const isPaused = () =>
      document.hidden || reduced.matches || window.MeddeyConfig?.reduceBackgroundWork?.() || dragging || slider.hasAttribute('data-hero-user-paused') || ((slider.hasAttribute('data-hero-pausable') && hovering) || slider.contains(document.activeElement));

    if (slider._heroInterval) {
      clearInterval(slider._heroInterval);
      slider._heroInterval = null;
    }

    slider._heroInterval = setInterval(() => {
      if (isPaused()) {
        return;
      }

      goTo(indexOfCurrent() + 1);
    }, seconds * 1000);

    slider.addEventListener('pointerenter', () => { hovering = true; });
    slider.addEventListener('pointerleave', () => { hovering = false; });
    track.addEventListener('pointerdown', () => { dragging = true; });
    document.addEventListener('pointerup', () => { dragging = false; });
  };

  const init = () => document.querySelectorAll('[data-hero-slider]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Customizer events
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target) return;
    const sliders = event.target.querySelectorAll ? event.target.querySelectorAll('[data-hero-slider]') : [];
    sliders.forEach((slider) => {
      if (slider._heroInterval) {
        clearInterval(slider._heroInterval);
        slider._heroInterval = null;
      }
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    if (!block || !block.hasAttribute('data-hero-slide')) return;
    const slider = block.closest('[data-hero-slider]');
    if (!slider) return;
    const track = slider.querySelector('[data-hero-track]');
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const index = slides.indexOf(block);
    if (index >= 0 && track) {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }
  });
})();


/* ==========================================================================
   MEDDEY INLINE EXPANDING PRODUCT CARD (FLIP ANIMATION & INTERACTIVE STATE)
   ========================================================================== */
(function() {
  'use strict';

  window.__meddeyQVCache = window.__meddeyQVCache || {};

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var num = Number(cents) / 100;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) {
      var format = window.themeVariables.settings.moneyFormat;
      var valStr = num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (format.indexOf('{{amount_no_decimals}}') >= 0 || format.indexOf('{{amount}}') >= 0) {
        return format.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, valStr);
      }
    }
    return 'Rs. ' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // FLIP (First, Last, Invert, Play) layout animation engine for smooth grid reflow
  function flipAnimate(parentGrid, mutateDOM) {
    if (window.MeddeyConfig?.enableSmoothExpansion === false || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) { mutateDOM(); return; }
    if (!parentGrid) {
      mutateDOM();
      return;
    }

    var cards = Array.prototype.slice.call(parentGrid.querySelectorAll('.product-item'));
    var firstPositions = new Map();

    cards.forEach(function(card) {
      firstPositions.set(card, card.getBoundingClientRect());
    });

    // Execute DOM changes (expand or collapse card)
    mutateDOM();

    // Measure new positions
    var lastPositions = new Map();
    cards.forEach(function(card) {
      lastPositions.set(card, card.getBoundingClientRect());
    });

    // Invert & Play
    cards.forEach(function(card) {
      var first = firstPositions.get(card);
      var last = lastPositions.get(card);
      if (!first || !last) return;

      var dx = first.left - last.left;
      var dy = first.top - last.top;

      if (dx !== 0 || dy !== 0) {
        card.style.transition = 'none';
        card.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      }
    });

    // Force browser reflow
    void parentGrid.offsetHeight;

    // Play: animate smoothly back to natural resting position (0, 0)
    requestAnimationFrame(function() {
      cards.forEach(function(card) {
        card.style.transition = 'transform 0.44s cubic-bezier(0.16, 1, 0.3, 1)';
        card.style.transform = '';
      });
    });

    setTimeout(function() {
      cards.forEach(function(card) {
        card.style.transition = '';
        card.style.transform = '';
      });
    }, 460);
  }

  function autoCenterCard(card) {
    if (!card || window.MeddeyConfig?.quickViewAutoCenter === false) return;
    requestAnimationFrame(function() {
      var offersGrid = card.closest('.meddey-offers-grid');
      if (offersGrid) {
        var targetLeft = card.offsetLeft - (offersGrid.clientWidth - card.clientWidth) / 2;
        offersGrid.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'smooth'
        });
      }

      var header = document.querySelector('.shopify-section--header');
      var headerHeight = header ? header.getBoundingClientRect().height : 80;

      var cardRect = card.getBoundingClientRect();
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      var cardDocTop = cardRect.top + currentScroll;

      var visibleViewportHeight = window.innerHeight - headerHeight;
      var cardHeight = cardRect.height || 380;

      var targetScroll;
      if (visibleViewportHeight > cardHeight) {
        targetScroll = cardDocTop - headerHeight - Math.round((visibleViewportHeight - cardHeight) / 2);
      } else {
        targetScroll = cardDocTop - headerHeight - 16;
      }

      window.scrollTo({
        top: Math.max(0, targetScroll),
        behavior: 'smooth'
      });
    });
  }

  function hydrateCardTemplate(card) {
    if (!card) return;
    var template = card.querySelector('.meddey-qv-template');
    var content = card.querySelector('.meddey-qv-content');
    var skeleton = card.querySelector('.meddey-qv-skeleton');

    if (template && content && (!content.children || !content.children.length)) {
      var frag = template.content ? template.content.cloneNode(true) : null;
      if (frag) {
        content.appendChild(frag);
      } else {
        content.innerHTML = template.innerHTML;
      }
      if (skeleton) { skeleton.hidden = true; skeleton.style.display = 'none'; }
      initExpandedCardEvents(card);
    } else if (content && content.children && content.children.length) {
      if (skeleton) { skeleton.hidden = true; skeleton.style.display = 'none'; }
    }
  }

  function collapseCard(card) {
    if (!card || !card.classList.contains('product-item--expanded')) return;
    var parentGrid = card.closest('.product-list__inner') || card.closest('.meddey-offers-grid') || card.parentElement;

    var rightPage = card.querySelector('.meddey-paper-page--right');
    if (rightPage) {
      rightPage.classList.add('is-folding');
    }

    setTimeout(function() {
      flipAnimate(parentGrid, function() {
        card.classList.remove('product-item--expanded');
        var expandedView = card.querySelector('.product-item__expanded-view');
        if (expandedView) {
          expandedView.hidden = true;
          expandedView.setAttribute('aria-hidden', 'true');
        }
        card.querySelectorAll('[data-action="meddey-expand-card"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
        card.style.height = '';
        card.style.maxHeight = '';
        card.style.minWidth = '';
        card.style.maxWidth = '';
        if (rightPage) {
          rightPage.classList.remove('is-folding');
        }
        if (parentGrid) {
          var stillExpanded = parentGrid.querySelector('.product-item.product-item--expanded');
          if (!stillExpanded) {
            parentGrid.classList.remove('has-expanded-card');
          }
        }
      });
    }, rightPage ? 200 : 0);
  }

  function expandCard(card, productUrl) {
    if (!card || card.classList.contains('product-item--expanded')) return;

    var parentGrid = card.closest('.product-list__inner') || card.closest('.meddey-offers-grid') || card.parentElement;
    var expandedView = card.querySelector('.product-item__expanded-view');
    var skeleton = card.querySelector('.meddey-qv-skeleton');
    var content = card.querySelector('.meddey-qv-content');
    var otherExpanded = document.querySelector('.product-item.product-item--expanded');

    // SCENARIO 1: SWITCHING BETWEEN PRODUCTS WHILE ALREADY OPEN
    if (otherExpanded && otherExpanded !== card) {
      var otherRight = otherExpanded.querySelector('.meddey-paper-page--right');
      if (otherRight) otherRight.classList.add('is-folding');

      hydrateCardTemplate(card);

      // Height stays auto: pinning it to the collapsed card's height clipped
      // the preview instead of letting the row grow to fit it.

      flipAnimate(parentGrid, function() {
        otherExpanded.classList.remove('product-item--expanded');
        var otherView = otherExpanded.querySelector('.product-item__expanded-view');
        if (otherView) {
          otherView.hidden = true;
          otherView.setAttribute('aria-hidden', 'true');
        }
        otherExpanded.querySelectorAll('[data-action="meddey-expand-card"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
        otherExpanded.style.height = '';
        otherExpanded.style.maxHeight = '';
        otherExpanded.style.minWidth = '';
        otherExpanded.style.maxWidth = '';
        if (otherRight) otherRight.classList.remove('is-folding');

        card.classList.add('product-item--expanded');
        if (expandedView) {
          expandedView.hidden = false;
          expandedView.setAttribute('aria-hidden', 'false');
        }
        card.querySelectorAll('[data-action="meddey-expand-card"]').forEach(function(btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
      });

      autoCenterCard(card);
      return;
    }

    // SCENARIO 2: OPENING FROM CLOSED GRID
    // Height stays auto — see the note in the switch-product path above.

    if (parentGrid && parentGrid.classList.contains('product-list__inner')) {
      var unexpandedCards = Array.prototype.slice.call(parentGrid.querySelectorAll('.product-item:not(.product-item--expanded)'));
      var firstTop = unexpandedCards[0] ? unexpandedCards[0].getBoundingClientRect().top : 0;
      var initialCols = unexpandedCards.filter(function(c) {
        return Math.abs(c.getBoundingClientRect().top - firstTop) < 15;
      }).length || 4;
      var expandedCols = Math.max(initialCols + 1, 5);

      parentGrid.style.setProperty('--expanded-grid-columns', expandedCols);
      parentGrid.classList.add('has-expanded-card');
    } else if (parentGrid) {
      parentGrid.classList.add('has-expanded-card');
    }

    hydrateCardTemplate(card);

    flipAnimate(parentGrid, function() {
      card.classList.add('product-item--expanded');
      if (expandedView) {
        expandedView.hidden = false;
        expandedView.setAttribute('aria-hidden', 'false');
      }
      card.querySelectorAll('[data-action="meddey-expand-card"]').forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    autoCenterCard(card);

    // Fallback: only make async HTTP fetch if card did NOT have an inline template
    if ((!content || !content.children || !content.children.length) && productUrl) {
      if (skeleton) { skeleton.hidden = false; skeleton.style.display = ''; }
      var fetchUrl = productUrl + (productUrl.indexOf('?') >= 0 ? '&' : '?') + 'view=quick-buy-drawer';
      fetch(fetchUrl)
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          window.__meddeyQVCache[productUrl] = html;
          if (content) content.innerHTML = html;
          if (skeleton) { skeleton.hidden = true; skeleton.style.display = 'none'; }
          initExpandedCardEvents(card);
        })
        .catch(function(err) {
          console.error('Failed to load quick view:', err);
          if (skeleton) { skeleton.hidden = true; skeleton.style.display = 'none'; }
        });
    }
  }

  function initExpandedCardEvents(containerOrCard) {
    if (!containerOrCard) return;
    var container = containerOrCard.classList && (containerOrCard.classList.contains('meddey-cart-preview-content') || containerOrCard.classList.contains('meddey-qv-content'))
      ? containerOrCard
      : (containerOrCard.querySelector('.meddey-cart-preview-content') || containerOrCard.querySelector('.meddey-qv-content') || containerOrCard);
    if (!container) return;
    var eventTarget = container.querySelector('.meddey-qv-form') || container;
    if (eventTarget.__meddeyEventsBound) return;
    eventTarget.__meddeyEventsBound = true;

    // 1. Gallery Image Switching & Arrows
    var stageImg = container.querySelector('.quick-buy-gallery__image');
    var thumbs = Array.from(container.querySelectorAll('.quick-buy-gallery__thumb'));
    var prevBtn = container.querySelector('.meddey-gallery-arrow--prev');
    var nextBtn = container.querySelector('.meddey-gallery-arrow--next');

    function setActiveThumb(index) {
      if (!thumbs.length || index < 0 || index >= thumbs.length) return;
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      var targetSrc = thumbs[index].dataset.targetSrc;
      if (stageImg && targetSrc) {
        stageImg.style.opacity = '0.6';
        stageImg.src = targetSrc;
        stageImg.onload = function() { stageImg.style.opacity = '1'; };
      }
    }

    thumbs.forEach(function(thumb, idx) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        setActiveThumb(idx);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var curIdx = thumbs.findIndex(function(t) { return t.classList.contains('is-active'); });
        var nextIdx = (curIdx <= 0) ? thumbs.length - 1 : curIdx - 1;
        setActiveThumb(nextIdx);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var curIdx = thumbs.findIndex(function(t) { return t.classList.contains('is-active'); });
        var nextIdx = (curIdx >= thumbs.length - 1) ? 0 : curIdx + 1;
        setActiveThumb(nextIdx);
      });
    }

    if (stageImg && thumbs.length > 1 && window.MeddeyConfig?.quickViewEnableSwipe !== false) {
      var swipeStart = null;
      stageImg.style.touchAction = 'pan-y';
      stageImg.draggable = false;
      stageImg.addEventListener('pointerdown', function(e) { if (e.button !== 0) return; swipeStart = {x:e.clientX,y:e.clientY,id:e.pointerId}; stageImg.setPointerCapture?.(e.pointerId); });
      stageImg.addEventListener('pointercancel', function() { swipeStart = null; });
      stageImg.addEventListener('pointerup', function(e) { if (!swipeStart) return; var dx=e.clientX-swipeStart.x, dy=e.clientY-swipeStart.y; swipeStart=null; if (Math.abs(dx)<40 || Math.abs(dx)<Math.abs(dy)) return; var current=thumbs.findIndex(function(t) { return t.classList.contains('is-active'); }); setActiveThumb((Math.max(0,current)+(dx<0?1:-1)+thumbs.length)%thumbs.length); });
    }

    // 2. Variant Selection Logic
    var variantsScript = container.querySelector('.meddey-qv-variants-data');
    var variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent.trim());
      } catch(e) {
        console.error('Variant JSON parse error:', e);
      }
    }

    var form = container.querySelector('.meddey-qv-form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceHighlight = container.querySelector('.price--highlight');
    var priceCompare = container.querySelector('.price--compare');
    var discountTag = container.querySelector('.meddey-qv-discount-tag');
    var submitBtn = container.querySelector('.meddey-qv-submit-btn');

    var optionGroups = container.querySelectorAll('.meddey-qv-option-group');
    optionGroups.forEach(function(group) {
      var pills = group.querySelectorAll('.meddey-qv-pill');
      var selectedLabel = group.querySelector('.meddey-qv-option-selected');

      pills.forEach(function(pill) {
        pill.addEventListener('click', function(e) {
          e.preventDefault();
          pills.forEach(function(p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          if (selectedLabel) selectedLabel.textContent = pill.dataset.value;

          var selectedVals = [];
          optionGroups.forEach(function(g) {
            var sel = g.querySelector('.meddey-qv-pill.is-selected');
            if (sel) selectedVals.push(sel.dataset.value);
          });

          var matchedVariant = variants.find(function(v) {
            if (!v.options) return false;
            return v.options.every(function(opt, i) { return opt === selectedVals[i]; });
          });

          if (!matchedVariant) {
            if (idInput) idInput.value = '';
            if (submitBtn) { submitBtn.disabled = true; var unavailableLabel = submitBtn.querySelector('span'); if (unavailableLabel) unavailableLabel.textContent = window.themeVariables?.strings?.productFormUnavailable || 'Unavailable'; }
            return;
          }
          if (matchedVariant) {
            if (idInput) idInput.value = matchedVariant.id;

            if (priceHighlight) {
              priceHighlight.textContent = formatMoney(matchedVariant.price);
            }
            if (priceCompare) {
              if (matchedVariant.compare_at_price > matchedVariant.price) {
                priceCompare.textContent = formatMoney(matchedVariant.compare_at_price);
                priceCompare.style.display = '';
                if (discountTag) {
                  // Same rule as the Liquid badges: only a discount of 5% or more gets a tag
                  var disc = (matchedVariant.compare_at_price - matchedVariant.price) * 100 / matchedVariant.compare_at_price;
                  discountTag.textContent = Math.round(disc) + '% OFF';
                  discountTag.style.display = disc >= 5 ? '' : 'none';
                }
              } else {
                priceCompare.style.display = 'none';
                if (discountTag) discountTag.style.display = 'none';
              }
            }

            if (matchedVariant.featured_image && matchedVariant.featured_image.src && stageImg) {
              stageImg.src = matchedVariant.featured_image.src;
            }

            if (submitBtn) {
              var btnSpan = submitBtn.querySelector('span');
              if (matchedVariant.available) {
                submitBtn.disabled = false;
                if (btnSpan) btnSpan.textContent = 'Add to Cart';
              } else {
                submitBtn.disabled = true;
                if (btnSpan) btnSpan.textContent = 'Sold Out';
              }
            }
          }
        });
      });
    });

    // 3. Quantity Stepper
    var qtyInput = container.querySelector('.meddey-qv-qty-input');
    var qtyBtns = container.querySelectorAll('.meddey-qv-qty-btn');
    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var val = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.action === 'increase') {
          val += 1;
        } else if (btn.dataset.action === 'decrease' && val > 1) {
          val -= 1;
        }
        qtyInput.value = val;
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        qtyInput.value = val;
      });
    }

    // 4. AJAX Add to Cart
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!submitBtn || submitBtn.disabled || !idInput || !idInput.value) return;

        submitBtn.disabled = true;
        var btnSpan = submitBtn.querySelector('span');
        var origText = btnSpan ? btnSpan.textContent : 'Add to Cart';
        if (btnSpan) btnSpan.textContent = 'Adding...';

        var status=form.querySelector('[data-add-status]'); if (status) status.textContent='';
        var formData = new FormData(form);
        fetch((window.themeVariables?.routes?.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          if (btnSpan) btnSpan.textContent = 'Added! ✓';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var miniCart = document.getElementById('mini-cart');
          if (miniCart) {
            if (typeof miniCart.open === 'function') miniCart.open();
            else miniCart.setAttribute('open', '');
          }
          // If added from inside the cart preview sidepan, return smoothly to cart view
          if (container.closest('.meddey-cart-preview-sidepan')) {
            setTimeout(function() {
              closeCartPreviewSidepan();
            }, 600);
          }
          setTimeout(function() {
            submitBtn.disabled = false;
            if (btnSpan) btnSpan.textContent = origText;
          }, 1400);
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
          if (btnSpan) btnSpan.textContent = 'Error';
          setTimeout(function() {
            submitBtn.disabled = false;
            if (btnSpan) btnSpan.textContent = origText;
          }, 1400);
        });
      });
    }
  }

  function bindQuickViewEvents(container) {
    if (typeof initExpandedCardEvents === 'function') {
      initExpandedCardEvents(container);
    }
  }

  // Meddey Cart Preview Sidepanel Controller
  function closeCartPreviewSidepan() {
    var miniCart = document.getElementById('mini-cart');
    var previewSidepan = document.getElementById('mini-cart-preview-sidepan');
    if (miniCart) {
      miniCart.classList.remove('has-active-preview');
    }
    if (previewSidepan) {
      previewSidepan.setAttribute('aria-hidden', 'true');
    }
    document.querySelectorAll('.mini-cart__recommendations .product-item.is-currently-previewed').forEach(function(item) {
      item.classList.remove('is-currently-previewed');
    });
  }

  function openCartPreviewSidepan(card, productUrl) {
    var miniCart = document.getElementById('mini-cart');
    var previewSidepan = document.getElementById('mini-cart-preview-sidepan');
    if (!miniCart || !previewSidepan) return;

    var skeleton = previewSidepan.querySelector('.meddey-cart-preview-skeleton');
    var content = previewSidepan.querySelector('.meddey-cart-preview-content');

    // Visual highlight on recommended card in sidebar
    document.querySelectorAll('.mini-cart__recommendations .product-item.is-currently-previewed').forEach(function(item) {
      item.classList.remove('is-currently-previewed');
    });
    if (card) {
      card.classList.add('is-currently-previewed');
    }

    // 0ms instant hydration from inline template if available
    var template = card ? card.querySelector('.meddey-qv-template') : null;
    if (template && content) {
      var clone = template.content ? template.content.cloneNode(true) : null;
      var wrap = document.createElement('div');
      if (clone) {
        wrap.appendChild(clone);
      } else {
        wrap.innerHTML = template.innerHTML;
      }
      content.innerHTML = wrap.innerHTML;
      if (skeleton) skeleton.style.display = 'none';
      content.style.display = 'block';

      miniCart.classList.add('has-active-preview');
      previewSidepan.setAttribute('aria-hidden', 'false');

      try {
        bindQuickViewEvents(content);
      } catch(err) {
        console.warn('Quick view event binding error:', err);
      }

      var body = previewSidepan.querySelector('.meddey-cart-preview-body');
      if (body) body.scrollTop = 0;
      return;
    }

    // Fallback: asynchronous HTTP fetch if template is not pre-rendered
    if (productUrl && content) {
      if (skeleton) skeleton.style.display = 'block';
      content.style.display = 'none';
      miniCart.classList.add('has-active-preview');
      previewSidepan.setAttribute('aria-hidden', 'false');

      var fetchUrl = productUrl.indexOf('?') > -1 ? productUrl + '&view=quick-buy-drawer' : productUrl + '?view=quick-buy-drawer';
      fetch(fetchUrl)
        .then(function(res) {
          if (!res.ok) throw new Error('Preview fetch failed');
          return res.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var booklet = doc.querySelector('.meddey-paper-booklet') || doc.body.firstElementChild;
          if (booklet) {
            content.innerHTML = booklet.outerHTML;
            if (skeleton) skeleton.style.display = 'none';
            content.style.display = 'block';
            try {
              bindQuickViewEvents(content);
            } catch(err) {
              console.warn('Quick view event binding error:', err);
            }
            var body = previewSidepan.querySelector('.meddey-cart-preview-body');
            if (body) body.scrollTop = 0;
          }
        })
        .catch(function(err) {
          console.error('Failed to load product preview sidepanel:', err);
          if (skeleton) skeleton.style.display = 'none';
        });
    }
  }

  // Reset preview sidepan when cart drawer is closed
  var miniCartEl = document.getElementById('mini-cart');
  if (miniCartEl) {
    miniCartEl.addEventListener('openable-element:close', function() {
      closeCartPreviewSidepan();
    });
  }

  // Pre-warm on hover or touchstart for 0ms latency
  function prewarmCard(card) {
    if (!card || card._prewarmed || window.MeddeyConfig?.reduceBackgroundWork?.()) return;
    card._prewarmed = true;
    hydrateCardTemplate(card);
  }

  document.addEventListener('pointerenter', function(e) {
    var card = e.target.closest ? e.target.closest('.product-item') : null;
    if (card) prewarmCard(card);
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function(e) {
    var card = e.target.closest ? e.target.closest('.product-item') : null;
    if (card) prewarmCard(card);
  }, { capture: true, passive: true });

  // Back to cart: captured before any drawer/overlay handler can act on the click,
  // so closing the preview never closes the drawer behind it.
  document.addEventListener('click', function(e) {
    var backBtn = e.target.closest ? e.target.closest('[data-action="meddey-back-to-cart"], .meddey-cart-preview-back-btn') : null;
    if (!backBtn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    closeCartPreviewSidepan();
    var miniCart = document.getElementById('mini-cart');
    if (miniCart && !miniCart.hasAttribute('open')) {
      try { miniCart.open = true; } catch (err) { miniCart.setAttribute('open', ''); }
    }
  }, true);

  // Delegated Event Listeners
  document.addEventListener('click', function(e) {
    // Clicking image in cart drawer recommendations opens preview sidepan
    var recImgLink = e.target.closest('.mini-cart__recommendations .product-item__image-wrapper');
    if (recImgLink) {
      e.preventDefault();
      e.stopPropagation();
      var recCard = recImgLink.closest('.product-item');
      var recUrl = recImgLink.getAttribute('href');
      if (recCard) {
        openCartPreviewSidepan(recCard, recUrl);
      }
      return;
    }

    // Expand button clicked (Eye icon or action button)
    var expandBtn = e.target.closest('[data-action="meddey-expand-card"], [data-action="meddey-quick-view"], .meddey-card-eye-btn');
    if (expandBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = expandBtn.closest('.product-item');
      var url = expandBtn.dataset.productUrl;
      if (!url && card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) url = link.getAttribute('href');
      }

      // If clicked inside cart drawer recommendations: replace cart with preview sidepan!
      if (expandBtn.closest('.mini-cart__recommendations, #mini-cart')) {
        if (card) {
          openCartPreviewSidepan(card, url);
        }
        return;
      }

      if (card) {
        expandCard(card, url);
      }
      return;
    }

    // Close button clicked
    var closeBtn = e.target.closest('[data-action="meddey-close-card"], .meddey-qv-close-btn');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = closeBtn.closest('.product-item');
      if (card) {
        collapseCard(card);
      }
      return;
    }

    // Clicked outside any expanded card
    var openCard = document.querySelector('.product-item.product-item--expanded');
    if (openCard && !openCard.contains(e.target)) {
      collapseCard(openCard);
    }
  });

  // Escape key collapses open card or closes preview sidepan
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var previewSidepan = document.getElementById('mini-cart-preview-sidepan');
      var miniCart = document.getElementById('mini-cart');
      if (miniCart && miniCart.classList.contains('has-active-preview')) {
        closeCartPreviewSidepan();
        return;
      }

      var openCard = document.querySelector('.product-item.product-item--expanded');
      if (openCard) {
        collapseCard(openCard);
      }
    }
  });

  /* --------------------------------------------------------------------------
     High-Speed Link Prefetcher & Zero-Latency Product Page Navigation
     -------------------------------------------------------------------------- */
  var _meddeyPrefetchedHrefs = new Set();

  function prefetchProductHref(href) {
    if (!href || typeof href !== 'string') return;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!url.pathname.includes('/products/')) return;
      var clean = url.pathname;
      if (_meddeyPrefetchedHrefs.has(clean)) return;
      _meddeyPrefetchedHrefs.add(clean);

      // 1. Speculation Rules API (Chrome 109+, Edge 109+) - fastest document prerender/prefetch
      if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
        var script = document.createElement('script');
        script.type = 'speculationrules';
        script.textContent = JSON.stringify({
          prefetch: [{ source: 'list', urls: [clean] }]
        });
        document.head.appendChild(script);
      }

      // 2. High-priority <link rel="prefetch"> tag
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = clean;
      link.as = 'document';
      link.fetchPriority = 'high';
      document.head.appendChild(link);

      // 3. Low-priority fetch cache pre-warm
      if (window.fetch) {
        fetch(clean, { priority: 'low', credentials: 'same-origin' }).catch(function() {});
      }
    } catch(e) {}
  }

  // Prefetch aggressively on hover, touch, and focus
  document.addEventListener('pointerenter', function(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (a && a.href) prefetchProductHref(a.href);
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (a && a.href) prefetchProductHref(a.href);
  }, { capture: true, passive: true });

  document.addEventListener('focusin', function(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (a && a.href) prefetchProductHref(a.href);
  }, { capture: true, passive: true });

  // Instant navigation on product name clicks inside cart/recommendations
  document.addEventListener('click', function(e) {
    var titleLink = e.target.closest ? e.target.closest('.mini-cart__recommendations a[href*="/products/"], .meddey-cart-preview-sidepan a[href*="/products/"], #mini-cart .product-item-meta__title a, #mini-cart a.product-item-meta__title') : null;
    if (!titleLink) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;

    var dest = titleLink.getAttribute('href');
    if (dest && !dest.startsWith('#')) {
      titleLink.classList.add('is-navigating');
      // Zero-latency direct browser navigation
      window.location.href = dest;
    }
  });

  // Automatically prefetch all visible recommended products in cart during idle time
  function prefetchCartRecommendations() {
    var recs = document.querySelectorAll('.mini-cart__recommendations a[href*="/products/"]');
    recs.forEach(function(r) {
      if (r.href) prefetchProductHref(r.href);
    });
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(prefetchCartRecommendations);
  } else {
    setTimeout(prefetchCartRecommendations, 1000);
  }

  // Watch for asynchronously rendered recommendations in cart drawer
  try {
    var recContainer = document.querySelector('.mini-cart__recommendations, cart-drawer-recommendations');
    if (recContainer && window.MutationObserver) {
      var recObserver = new MutationObserver(function() {
        prefetchCartRecommendations();
      });
      recObserver.observe(recContainer, { childList: true, subtree: true });
    }
  } catch(e) {}
})();


/* ==========================================================================
   MEDDEY ENTERPRISE SELECTION-BASED CHECKOUT CONTROLLER
   - Default: All cart items selected
   - Dynamic live subtotal and dynamic checkout button text
   - "Select All" toggle toolbar with item count sync
   - Checkout with ONLY checked items via Shopify Cart Permalink (/cart/v1:q1,v2:q2?checkout)
   - Unselected items remain safely in the customer's cart
   ========================================================================== */
(function() {
  'use strict';

  function formatPrice(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var num = Number(cents) / 100;
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) {
      var format = window.themeVariables.settings.moneyFormat;
      var hasNoDecimals = /amount_no_decimals/.test(format);
      var valStr = hasNoDecimals
        ? Math.round(num).toLocaleString('en-IN')
        : num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var moneyRegex = /\{\{\s*amount(?:_no_decimals)?(?:_with_comma_separator)?\s*\}\}/g;
      if (moneyRegex.test(format)) {
        return format.replace(moneyRegex, valStr);
      }
    }
    return 'Rs. ' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var recovery = null;
  try { recovery = window.createMeddeyCartRecovery({fetch:window.fetch.bind(window),storage:window.localStorage,cartUrl:window.themeVariables?.routes?.cartUrl || '/cart'}); } catch(e) {}
  function cartError(message) {
    var cart = document.getElementById('mini-cart');
    if (!cart) return;
    var status = cart.querySelector('[data-meddey-cart-error]');
    if (!status) { status=document.createElement('p'); status.dataset.meddeyCartError=''; status.setAttribute('role','alert'); status.style.cssText='margin:12px 20px;color:#b42318'; (cart.querySelector('footer') || cart.querySelector('.drawer__content') || cart).prepend(status); }
    status.textContent=message;
  }
  function cartLock(work) { return navigator.locks ? navigator.locks.request('meddey-cart-selection',work) : work(); }
  function restoreSavedCart() {
    if (!recovery) return Promise.resolve();
    return cartLock(function() { return recovery.restore(); }).then(function(cart) { if (cart) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}})); return true; }).catch(function(error) { cartError(error.message); return false; });
  }
  restoreSavedCart();
  window.addEventListener('pageshow',function(event) {
    if (!event.persisted) return;
    var cart=document.getElementById('mini-cart');
    if (cart) { cart.__meddeyCheckingOut=false; cart.querySelector('#meddey-checkout-btn')?.removeAttribute('aria-busy'); }
    restoreSavedCart().then(function() { MeddeyCartSelection.init(); });
  });

  var MeddeyCartSelection = {
    init: function() {
      var miniCart = document.getElementById('mini-cart');
      if (!miniCart) return;

      var selectAllCb = miniCart.querySelector('#meddey-select-all-checkbox');
      var toggleAllBtn = miniCart.querySelector('#meddey-toggle-all-btn');
      var itemCheckboxes = Array.prototype.slice.call(miniCart.querySelectorAll('.meddey-cart-item-checkbox'));
      var checkoutBtn = miniCart.querySelector('#meddey-checkout-btn') || miniCart.querySelector('button[name="checkout"]');

      if (!itemCheckboxes.length) {
        return;
      }

      // Restore unselected state from sessionStorage if any (default is ALL checked)
      var unselectedKeys = [];
      try {
        var stored = sessionStorage.getItem('meddey_unselected_keys');
        if (stored) unselectedKeys = JSON.parse(stored);
      } catch(e) {}

      if (Array.isArray(unselectedKeys) && unselectedKeys.length > 0) {
        itemCheckboxes.forEach(function(cb) {
          var lineKey = cb.dataset.lineKey || cb.dataset.variantId;
          if (unselectedKeys.indexOf(lineKey) >= 0) {
            cb.checked = false;
          } else {
            cb.checked = true;
          }
        });

        // A restore that leaves nothing selected locks the shopper out of checkout for
        // the rest of the session (the button only warns "select at least one item"),
        // and an empty selection has no valid use. Recover instead of persisting it.
        if (!itemCheckboxes.some(function(cb) { return cb.checked; })) {
          itemCheckboxes.forEach(function(cb) { cb.checked = true; });
          try { sessionStorage.removeItem('meddey_unselected_keys'); } catch(e) {}
        }
      }

      // Recalculate totals and sync UI
      function updateSelectionUI() {
        selectAllCb = miniCart.querySelector('#meddey-select-all-checkbox');
        toggleAllBtn = miniCart.querySelector('#meddey-toggle-all-btn');
        checkoutBtn = miniCart.querySelector('#meddey-checkout-btn') || miniCart.querySelector('button[name=checkout]');
        var currentItems = Array.prototype.slice.call(miniCart.querySelectorAll('.meddey-cart-item-checkbox'));
        var checkedCbs = currentItems.filter(function(cb) { return cb.checked; });
        var checkedCount = checkedCbs.length;
        var totalCount = currentItems.length;

        // Save unselected keys in sessionStorage
        var currentUnselected = [];
        currentItems.forEach(function(cb) {
          var lineKey = cb.dataset.lineKey || cb.dataset.variantId;
          var card = cb.closest('.line-item, .cart-item');
          if (cb.checked) {
            if (card) {
              card.classList.remove('is-deselected');
              card.style.opacity = '1';
            }
          } else {
            if (lineKey) currentUnselected.push(lineKey);
            if (card) {
              card.classList.add('is-deselected');
              card.style.opacity = '0.52';
            }
          }
        });

        try {
          if (checkedCount > 0) {
            sessionStorage.setItem('meddey_unselected_keys', JSON.stringify(currentUnselected));
          } else {
            sessionStorage.removeItem('meddey_unselected_keys');
          }
        } catch(e) {}

        // Calculate sum of selected lines
        var selectedTotalCents = 0;
        checkedCbs.forEach(function(cb) {
          var price = parseInt(cb.dataset.linePrice || '0', 10);
          selectedTotalCents += price;
        });

        var formattedTotal = formatPrice(selectedTotalCents);

        var selectedCountLabel = miniCart.querySelector('#meddey-selected-count-label');
        if (selectedCountLabel) selectedCountLabel.textContent = checkedCount;

        var totalCountLabel = miniCart.querySelector('#meddey-total-count-label');
        if (totalCountLabel) totalCountLabel.textContent = totalCount;

        if (selectAllCb) {
          if (checkedCount === totalCount) {
            selectAllCb.checked = true;
            selectAllCb.indeterminate = false;
          } else if (checkedCount > 0) {
            selectAllCb.checked = false;
            selectAllCb.indeterminate = true;
          } else {
            selectAllCb.checked = false;
            selectAllCb.indeterminate = false;
          }
        }

        if (toggleAllBtn) {
          toggleAllBtn.textContent = (checkedCount === 0) ? 'Select All' : 'Deselect All';
        }

        var footerCount = miniCart.querySelector('#meddey-cart-footer-count');
        if (footerCount) footerCount.textContent = checkedCount;

        var footerSubtotal = miniCart.querySelector('#meddey-cart-footer-subtotal');
        if (footerSubtotal) footerSubtotal.textContent = formattedTotal;

        var checkoutBtnCount = miniCart.querySelector('#meddey-checkout-btn-count');
        if (checkoutBtnCount) checkoutBtnCount.textContent = checkedCount;

        var checkoutBtnTotal = miniCart.querySelector('#meddey-checkout-btn-total');
        if (checkoutBtnTotal) checkoutBtnTotal.textContent = formattedTotal;

        if (checkoutBtn) {
          checkoutBtn.disabled = checkedCount === 0 || !!miniCart.__meddeyCheckingOut;
          if (checkedCount === 0) {
            checkoutBtn.classList.add('is-disabled');
            checkoutBtn.setAttribute('aria-disabled', 'true');
            checkoutBtn.style.opacity = '0.5';
            checkoutBtn.style.cursor = 'not-allowed';
          } else {
            checkoutBtn.classList.remove('is-disabled');
            checkoutBtn.removeAttribute('aria-disabled');
            checkoutBtn.style.opacity = '1';
            checkoutBtn.style.cursor = 'pointer';
          }
        }
      }

      // Idempotent Event Delegation on miniCart
      if (!miniCart._selectionDelegated) {
        miniCart._selectionDelegated = true;

        miniCart.addEventListener('change', function(e) {
          if (e.target.id === 'meddey-select-all-checkbox') {
            var shouldCheck = e.target.checked;
            var cbs = miniCart.querySelectorAll('.meddey-cart-item-checkbox');
            cbs.forEach(function(cb) { cb.checked = shouldCheck; });
            updateSelectionUI();
          } else if (e.target.classList.contains('meddey-cart-item-checkbox')) {
            updateSelectionUI();
          }
        });

        miniCart.addEventListener('click', async function(e) {
          var toggleBtn = e.target.closest('#meddey-toggle-all-btn, .meddey-toggle-all-btn');
          if (toggleBtn) {
            e.preventDefault();
            var cbs = Array.prototype.slice.call(miniCart.querySelectorAll('.meddey-cart-item-checkbox'));
            var anyChecked = cbs.some(function(cb) { return cb.checked; });
            var shouldCheck = !anyChecked;
            cbs.forEach(function(cb) { cb.checked = shouldCheck; });
            updateSelectionUI();
            return;
          }

          var chkBtn = e.target.closest('#meddey-checkout-btn, button[name="checkout"]');
          if (chkBtn && chkBtn.id === 'meddey-checkout-btn') {
            var cbs = Array.prototype.slice.call(miniCart.querySelectorAll('.meddey-cart-item-checkbox'));
            var checkedCbs = cbs.filter(function(cb) { return cb.checked; });
            var checkedCount = checkedCbs.length;
            var totalCount = cbs.length;

            if (checkedCount === 0) {
              e.preventDefault();
              e.stopPropagation();
              alert('Please select at least one item to proceed to checkout.');
              return false;
            }

            if (checkedCount === totalCount) {
              var hasSavedItems = false;
              try { hasSavedItems = !!localStorage.getItem('meddey_saved_cart_items'); } catch(error) {}
              if (hasSavedItems) { e.preventDefault(); e.stopPropagation(); if (await restoreSavedCart()) cartError('Saved items restored. Review your cart and choose checkout again.'); return false; }
              e.preventDefault();
              e.stopPropagation();
              window.meddeyGoToCheckout(chkBtn);   /* payment gateway, not Shopify native */
              return false;
            }

            e.preventDefault();
            e.stopPropagation();
            if (miniCart.__meddeyCheckingOut) return false;
            if (!recovery) { cartError('Enable browser storage before checking out selected items.'); return false; }
            miniCart.__meddeyCheckingOut=true;
            chkBtn.disabled=true;
            chkBtn.setAttribute('aria-busy','true');
            try {
              var keys=checkedCbs.map(function(cb) { return cb.dataset.lineKey; });
              var noteInput=miniCart.querySelector('textarea[name=note]');
              await cartLock(function() { return recovery.prepare(keys,noteInput ? noteInput.value : undefined); });
              window.meddeyGoToCheckout(chkBtn);
            } catch(error) {
              await restoreSavedCart();
              cartError(error.message);
              miniCart.__meddeyCheckingOut=false;
              chkBtn.removeAttribute('aria-busy');
              updateSelectionUI();
            }
            return false;
          }
        });
      }

      // Initial run
      updateSelectionUI();
    }
  };

  // Re-bind when cart updates or re-renders
  document.documentElement.addEventListener('cart:updated', function() {
    setTimeout(function() { MeddeyCartSelection.init(); }, 80);
  });

  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(function() { MeddeyCartSelection.init(); }, 120);
  });

  // Observe mini-cart DOM replacement safely
  var cartMount = document.getElementById('mini-cart');
  if (cartMount && 'MutationObserver' in window) {
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      var hasRelevantMutation = mutations.some(function(m) {
        return m.type === 'childList' && m.addedNodes.length > 0 &&
          Array.prototype.some.call(m.addedNodes, function(node) {
            return node.nodeType === 1 && (node.matches && (node.matches('.line-item, .cart-item, cart-drawer') || node.querySelector('.line-item, .cart-item')));
          });
      });
      if (hasRelevantMutation) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          MeddeyCartSelection.init();
        }, 80);
      }
    });
    observer.observe(cartMount, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', MeddeyCartSelection.init);
  } else {
    MeddeyCartSelection.init();
  }

  window.MeddeyCartSelection = MeddeyCartSelection;
})();


/* ==========================================================================
     Meddey Video Auto-Detection: Hover Autoplay, Mobile Tap, Lazy Playback
     ========================================================================== */
  function initCardVideos() {
    var videoWraps = document.querySelectorAll('.meddey-card-video-wrap');
    if (!videoWraps.length) return;

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var player = entry.target.querySelector('.meddey-card-video-player');
          if (player && !entry.isIntersecting && !player.paused) {
            player.pause();
            player.classList.remove('is-playing');
          }
        });
      }, { threshold: 0.1 });
    }

    videoWraps.forEach(function(wrap) {
      if (wrap._videoInitialized) return;
      wrap._videoInitialized = true;

      var card = wrap.closest('.product-item');
      var player = wrap.querySelector('.meddey-card-video-player');
      var badge = wrap.querySelector('.meddey-card-video-badge');
      var videoType = wrap.dataset.videoType;
      var videoSrc = wrap.dataset.videoSrc;

      if (observer && card) observer.observe(card);

      if (player && videoSrc) {
        if (card) {
          card.addEventListener('mouseenter', function() {
            if (!player.src && videoSrc) {
              player.src = videoSrc;
              player.load();
            }
            player.muted = true;
            player.play().then(function() {
              player.classList.add('is-playing');
            }).catch(function() {});
          });

          card.addEventListener('mouseleave', function() {
            player.pause();
            player.classList.remove('is-playing');
          });
        }

        if (badge) {
          badge.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (player.paused) {
              if (!player.src) {
                player.src = videoSrc;
                player.load();
              }
              player.play().then(function() {
                player.classList.add('is-playing');
              });
            } else {
              player.pause();
              player.classList.remove('is-playing');
            }
          });
        }
      } else if (badge && (videoType === 'youtube' || videoType === 'vimeo')) {
        badge.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var qvBtn = card ? card.querySelector('[data-action="meddey-quick-view"], [data-action="meddey-expand-card"]') : null;
          if (qvBtn) qvBtn.click();
        });
      }
    });
  }
  /* ==========================================================================
     Meddey Portable In-Grid Custom Block Mounter
     Transplants any <div data-meddey-in-grid="X"> directly after product #X
     ========================================================================== */
  var __meddeyInGridSources = null;

  function mountDescriptionInGridBlocks() {
    var productList = document.querySelector('.product-facet__product-list .product-list__inner, .product-list .product-list__inner');
    if (!productList) return;
    if (isMountingInGrid) return;
    isMountingInGrid = true;

    try {
      if (!__meddeyInGridSources) {
        var initialBlocks = Array.from(document.querySelectorAll('[data-meddey-in-grid]:not(.meddey-in-grid-card--transplanted)'));
        if (initialBlocks.length > 0) {
          __meddeyInGridSources = initialBlocks.map(function(block) {
            return {
              targetPos: parseInt(block.getAttribute('data-meddey-in-grid'), 10),
              colSpan: block.getAttribute('data-column-span') || block.getAttribute('data-col-span') || '1',
              html: block.outerHTML
            };
          }).filter(function(item) {
            return !isNaN(item.targetPos) && item.targetPos >= 1;
          });
          initialBlocks.forEach(function(b) {
            b.style.display = 'none';
          });
        }
      }

      if (!__meddeyInGridSources || !__meddeyInGridSources.length) return;

      // Remove any previously mounted clones
      var oldClones = productList.querySelectorAll('.meddey-in-grid-card--transplanted');
      oldClones.forEach(function(el) { el.remove(); });

      var productCards = Array.from(productList.children).filter(function(child) {
        return child.classList.contains('product-item');
      });

      __meddeyInGridSources.forEach(function(item) {
        if (item.targetPos <= productCards.length) {
          var targetCard = productCards[item.targetPos - 1];
          if (targetCard) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = item.html;
            var clone = tempDiv.firstElementChild;
            if (clone) {
              clone.style.display = '';
              clone.classList.add('meddey-in-grid-card', 'meddey-in-grid-card--transplanted');
              if (item.colSpan === '2') {
                clone.classList.add('meddey-in-grid-card--span-2');
              }
              targetCard.parentNode.insertBefore(clone, targetCard.nextSibling);
            }
          }
        }
      });
    } finally {
      setTimeout(function() {
        isMountingInGrid = false;
      }, 100);
    }
  }

  var isMountingInGrid = false;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCardVideos();
      mountDescriptionInGridBlocks();
    });
  } else {
    initCardVideos();
    mountDescriptionInGridBlocks();
  }

  document.addEventListener('shopify:section:load', function() {
    initCardVideos();
    mountDescriptionInGridBlocks();
  });

  // Observe product list updates (e.g. AJAX filtering and sorting) safely without infinite loops
  var facetMain = document.querySelector('.product-facet__main, #facet-main, .product-facet');
  if (facetMain && 'MutationObserver' in window) {
    var facetDebounceTimer = null;
    var facetObs = new MutationObserver(function(mutations) {
      if (isMountingInGrid) return;
      var hasExternalNodes = mutations.some(function(m) {
        if (m.type !== 'childList' || !m.addedNodes.length) return false;
        return Array.prototype.some.call(m.addedNodes, function(node) {
          if (node.nodeType !== 1) return false;
          return !node.classList.contains('meddey-in-grid-card--transplanted') &&
                 !node.querySelector('.meddey-in-grid-card--transplanted');
        });
      });
      if (hasExternalNodes) {
        clearTimeout(facetDebounceTimer);
        facetDebounceTimer = setTimeout(function() {
          mountDescriptionInGridBlocks();
        }, 120);
      }
    });
    facetObs.observe(facetMain, { childList: true, subtree: true });
  }

/* Hand the checkout to Zecpe (the store payment gateway) rather than Shopify native.
   The mini-cart button is exempted from Zecpe in snippets/ecom360.liquid so the theme
   partial-checkout flow can run first; this is where that flow hands back over.
   Falls back to Shopify checkout if Zecpe is unavailable, so checkout is never dead. */
window.meddeyGoToCheckout = function(button) {
  var fallback = (window.themeVariables?.routes?.rootUrl || '/') + 'checkout';
  /* Gateway switched off in Theme settings -> Checkout: straight to Shopify rather
     than polling 4s for a gateway that is never going to load. */
  if (window.meddeyZecpeEnabled !== true) { window.location.href = fallback; return; }
  var go = function() {
    try {
      if (typeof window.handleOcc === 'function') { window.handleOcc(button || false); return true; }
    } catch (error) {}
    return false;
  };
  if (go()) return;
  try { if (typeof window.triggerZecpeSetup === 'function') window.triggerZecpeSetup(); } catch (error) {}
  var tries = 0;
  var poll = setInterval(function() {
    if (go()) { clearInterval(poll); return; }
    if (++tries > 16) { clearInterval(poll); window.location.href = fallback; }   /* ~4s, then Shopify */
  }, 250);
};
